import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
new Vue({
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]






